
import { useAuth } from "@/contexts/AuthContext";
import { TestHistory } from "@/components/profile/TestHistory";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const TestHistoryPage = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <div className="container max-w-7xl mx-auto py-8 px-6 md:px-12 lg:px-24">
        <div className="flex items-center gap-2 mb-6">
          <h1 className="text-3xl font-bold text-foreground">Test History</h1>
        </div>
        
        <Card className="bg-card border-border rounded-sm">
          <CardHeader>
            <CardTitle className="text-foreground">Your Test Results</CardTitle>
          </CardHeader>
          <CardContent>
            <TestHistory candidateId={user?.id} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TestHistoryPage;
